"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _spinner = _interopRequireDefault(require("cccisd-icons/spinner11"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _Assignment = _interopRequireDefault(require("../Assignment"));
var _DisplayMessage = _interopRequireDefault(require("../DisplayMessage"));
var _CompletionButton = _interopRequireDefault(require("../WithPasscode/CompletionButton"));
var _helpers = require("../WithPasscode/helpers.js");
var _PlayerLayout = _interopRequireDefault(require("../PlayerLayout"));
var _navigations = _interopRequireDefault(require("../navigations"));
var _getFlowProgress = _interopRequireDefault(require("../DeploymentEvaluator/getFlowProgress.js"));
var _throttle2 = _interopRequireDefault(require("lodash/throttle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var DeploymentPlayer = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function DeploymentPlayer(props) {
    var _this;
    _classCallCheck(this, DeploymentPlayer);
    _this = _callSuper(this, DeploymentPlayer, [props]);
    _defineProperty(_this, "time", null);
    _defineProperty(_this, "componentWillUnmount", function () {
      _this.unassignTimer();
    });
    _defineProperty(_this, "assignTimer", function () {
      if (_this.state.settings.autoLogout && !_this.time && !_this.state.showLogoutMsg) {
        document.addEventListener('click', _this.resetTimer, true);
        document.addEventListener('keydown', _this.resetTimer, true);
        document.addEventListener('mousemove', _this.resetTimer, true);
      }
    });
    _defineProperty(_this, "unassignTimer", function () {
      document.removeEventListener('click', _this.resetTimer, true);
      document.removeEventListener('keydown', _this.resetTimer, true);
      document.removeEventListener('mousemove', _this.resetTimer, true);
    });
    _defineProperty(_this, "getDeploymentData", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _data$assignmentProgr, _data$assignmentProgr2, _data$assignmentProgr3;
      var _this$props, deploymentId, deploymentHandle, allowRetake, language, pawnId, pawnHash, surveylist, result, data, deployment;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props = _this.props, deploymentId = _this$props.deploymentId, deploymentHandle = _this$props.deploymentHandle, allowRetake = _this$props.allowRetake, language = _this$props.language, pawnId = _this$props.pawnId, pawnHash = _this$props.pawnHash, surveylist = _this$props.surveylist;
            if (!(!deploymentId && !deploymentHandle)) {
              _context.n = 1;
              break;
            }
            console.error('Missing both deploymentId and deploymentHandle.');
            _this.setState({
              isLoading: false,
              show404: true
            });
            return _context.a(2);
          case 1:
            _context.n = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.player.assignment'), _objectSpread(_objectSpread(_objectSpread({}, deploymentId ? {
              deploymentId: deploymentId
            } : {}), deploymentHandle ? {
              deploymentHandle: deploymentHandle
            } : {}), {}, {
              language: language,
              pawnId: pawnId,
              pawnHash: pawnHash,
              surveylist: surveylist
            }));
          case 2:
            result = _context.v;
            data = result.data.data;
            if (!(!data || !data.deployment)) {
              _context.n = 3;
              break;
            }
            _this.setState({
              isLoading: false,
              show404: true
            });
            return _context.a(2);
          case 3:
            if (data.pawn) {
              _context.n = 4;
              break;
            }
            _this.setState({
              isLoading: false,
              show404: true,
              type: data.deployment.type
            });
            return _context.a(2);
          case 4:
            deployment = data.deployment;
            if (typeof allowRetake === 'boolean') {
              deployment.settings.allowRetake = allowRetake;
            }
            _this.setState({
              allSurveyProgress: data.surveyProgress,
              assignmentData: _objectSpread(_objectSpread({}, deployment.assignment.settings), {}, {
                assignmentId: deployment.assignment.id,
                handle: deployment.assignment.handle,
                label: deployment.assignment.label,
                surveylists: data.surveylist
              }),
              deploymentId: deployment.id,
              type: deployment.type,
              parentDeploymentId: deployment.parent_deployment_id,
              relatedDeploymentId: deployment.related_deployment_id,
              settings: deployment.settings,
              showReviewButtonOnCompletion: (!deployment.settings.postCompletionAction || deployment.settings.postCompletionAction === 'message') && !deployment.settings.logoutOnCompletion && deployment.settings.showReviewButtonOnCompletion,
              flowProgress: (0, _getFlowProgress["default"])(data),
              language: (_data$assignmentProgr = data.assignmentProgress) === null || _data$assignmentProgr === void 0 ? void 0 : _data$assignmentProgr.language,
              flowList: (_data$assignmentProgr2 = data.assignmentProgress) === null || _data$assignmentProgr2 === void 0 ? void 0 : (_data$assignmentProgr3 = _data$assignmentProgr2.surveylist) === null || _data$assignmentProgr3 === void 0 ? void 0 : _data$assignmentProgr3.handle,
              isLoading: false,
              pawn: data.pawn
            });
          case 5:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "getSelectedCondition", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(language, flowList, pawnId) {
        var _this$state, deploymentId, settings, response, conditionKey, dcwRedirectHash, bcConfig, allBranches, allConditions, selectedCondition, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this$state = _this.state, deploymentId = _this$state.deploymentId, settings = _this$state.settings;
              response = null;
              _context2.p = 1;
              _context2.n = 2;
              return _cccisdAxios["default"].post(Boilerplate.route('api.assignmentProgress.branchedCompletionAction'), {
                deploymentId: deploymentId,
                flowlist: flowList,
                language: language,
                pawnId: pawnId
              });
            case 2:
              response = _context2.v;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.error(_t);
              _this.setState({
                show404: true
              });
              return _context2.a(2, null);
            case 4:
              if (!(response.data.status !== 'success')) {
                _context2.n = 5;
                break;
              }
              console.error('Response failed: ' + response.data.status);
              _this.setState({
                show404: true
              });
              return _context2.a(2, null);
            case 5:
              conditionKey = (0, _get2["default"])(response, 'data.data.conditionKey', 0);
              dcwRedirectHash = (0, _get2["default"])(response, 'data.data.dcwRedirectHash', '');
              bcConfig = settings.branchedCompletionConfig;
              allBranches = [].concat(_toConsumableArray(bcConfig.branches || []), [bcConfig.defaultBranch]);
              allConditions = allBranches.reduce(function (acc, b) {
                return [].concat(_toConsumableArray(acc), _toConsumableArray(b.conditions));
              }, []);
              selectedCondition = allConditions.find(function (c) {
                return Number(c.key) === Number(conditionKey);
              }) || {};
              selectedCondition.dcwRedirectHash = dcwRedirectHash;
              return _context2.a(2, selectedCondition);
          }
        }, _callee2, null, [[1, 3]]);
      }));
      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "logoutOnCompletion", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(settings) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!settings.logoutOnCompletion) {
                _context3.n = 1;
                break;
              }
              _context3.n = 1;
              return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.logout'));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onAlreadyComplete", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(language, flowList, pawnId) {
        var settings, selectedCondition;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              settings = _this.state.settings;
              if (!settings.allowRetake) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _this.setState({
                showCompletedMsg: true
              });
              if (!(settings.postCompletionAction === 'branch')) {
                _context4.n = 3;
                break;
              }
              _context4.n = 2;
              return _this.getSelectedCondition(language, flowList, pawnId);
            case 2:
              selectedCondition = _context4.v;
              if (!(selectedCondition !== null && selectedCondition.action === 'dcwRedirect' && selectedCondition.dcwRedirectHash)) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2, window.location.replace(Boilerplate.url("/d/".concat(selectedCondition.dcwRedirectHash))));
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function (_x5, _x6, _x7) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "setLocalOnComplete", function () {
      var _assignmentData$navig;
      var _this$state2 = _this.state,
        assignmentData = _this$state2.assignmentData,
        settings = _this$state2.settings;

      // Modules player has the option to show completion message or just kick user back to dashboard
      var isSuppressBecauseModulePlayer = ((assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.navigation) || '').startsWith('module') && (assignmentData === null || assignmentData === void 0 ? void 0 : (_assignmentData$navig = assignmentData.navigationSettings) === null || _assignmentData$navig === void 0 ? void 0 : _assignmentData$navig.suppressOnComplete) === true;

      // Course Wrapper should let users see certificate instead of showing completion message
      var isSuppressBecauseCourseWrapper = ((assignmentData === null || assignmentData === void 0 ? void 0 : assignmentData.navigation) || '').startsWith('courseWrapper');
      var localOnComplete = function localOnComplete() {};
      if (settings.postCompletionAction === 'branch') {
        // Call back-end for next action
        localOnComplete = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(language, flowList, pawnId) {
            var selectedCondition, _t2;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.n) {
                case 0:
                  _context5.n = 1;
                  return _this.getSelectedCondition(language, flowList, pawnId);
                case 1:
                  selectedCondition = _context5.v;
                  if (selectedCondition === null) {
                    _this.setState({
                      show404: true
                    });
                  }
                  _context5.n = 2;
                  return _this.logoutOnCompletion(selectedCondition);
                case 2:
                  _t2 = selectedCondition.action;
                  _context5.n = _t2 === 'url' ? 3 : _t2 === 'dcwRedirect' ? 4 : _t2 === 'message' ? 6 : 7;
                  break;
                case 3:
                  return _context5.a(2, window.location.replace(selectedCondition.completionUrl));
                case 4:
                  if (!selectedCondition.dcwRedirectHash) {
                    _context5.n = 5;
                    break;
                  }
                  return _context5.a(2, window.location.replace(Boilerplate.url("/d/".concat(selectedCondition.dcwRedirectHash))));
                case 5:
                  return _context5.a(3, 8);
                case 6:
                  _this.setState({
                    completionMessage: selectedCondition.completionMessage,
                    showReviewButtonOnCompletion: !selectedCondition.logoutOnCompletion && selectedCondition.showReviewButtonOnCompletion
                  });
                  return _context5.a(3, 8);
                case 7:
                  return _context5.a(3, 8);
                case 8:
                  // Normal behavior for 'message' and fall-back behavior for
                  // 'dcwRedirect' and action not found
                  _this.setState({
                    showCompletionMsg: true
                  });
                case 9:
                  return _context5.a(2);
              }
            }, _callee5);
          }));
          return function localOnComplete(_x8, _x9, _x0) {
            return _ref5.apply(this, arguments);
          };
        }();
      } else if ((settings.sendToUrl || settings.postCompletionAction === 'url') && settings.completionUrl) {
        localOnComplete = /*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.n) {
                case 0:
                  _context6.n = 1;
                  return _this.logoutOnCompletion(settings);
                case 1:
                  window.location.replace(settings.completionUrl);
                case 2:
                  return _context6.a(2);
              }
            }, _callee6);
          }));
          return function localOnComplete() {
            return _ref6.apply(this, arguments);
          };
        }();
      } else if (settings.completionMessage && !isSuppressBecauseModulePlayer && !isSuppressBecauseCourseWrapper) {
        localOnComplete = /*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.n) {
                case 0:
                  _context7.n = 1;
                  return _this.logoutOnCompletion(settings);
                case 1:
                  _this.setState({
                    showCompletionMsg: true
                  });
                case 2:
                  return _context7.a(2);
              }
            }, _callee7);
          }));
          return function localOnComplete() {
            return _ref7.apply(this, arguments);
          };
        }();
      }
      return localOnComplete;
    });
    _defineProperty(_this, "getPlayerLayout", function (children) {
      var assignmentData = _this.state.assignmentData;
      return /*#__PURE__*/_react["default"].createElement(_PlayerLayout["default"], {
        frameHandle: assignmentData.frameStyleId,
        showHeader: assignmentData.showHeader,
        showFooter: assignmentData.showFooter,
        settings: assignmentData.frameStyleSettings || {},
        navigation: assignmentData.navigation
      }, children);
    });
    _defineProperty(_this, "autoLogout", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var _this$state$settings, individualPasscode, respondentConfig, usingPasscode, pathname, urlAfterLogout;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            _this$state$settings = _this.state.settings, individualPasscode = _this$state$settings.individualPasscode, respondentConfig = _this$state$settings.respondentConfig;
            usingPasscode = respondentConfig === 'manual' && individualPasscode;
            _context8.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('api.nexus.logout'));
          case 1:
            if (!_this.props.onLogout) {
              _context8.n = 2;
              break;
            }
            _context8.n = 2;
            return _this.props.onLogout();
          case 2:
            if (usingPasscode) {
              pathname = window.location.pathname;
              urlAfterLogout = (0, _helpers.passcodeLandingPage)(pathname);
              window.location.replace(Boilerplate.url(urlAfterLogout));
            }
            _this.setState({
              showLogoutMsg: true
            });
            _this.unassignTimer();
          case 3:
            return _context8.a(2);
        }
      }, _callee8);
    })));
    _defineProperty(_this, "resetTimer", (0, _throttle2["default"])(function () {
      var _this$state$settings2 = _this.state.settings,
        autoLogout = _this$state$settings2.autoLogout,
        autoLogoutTime = _this$state$settings2.autoLogoutTime;
      var customLength = +autoLogoutTime !== 20;
      var inMilliseconds = +autoLogoutTime * 60 * 1000;
      clearTimeout(_this.time);
      _this.time = setTimeout(_this.autoLogout, autoLogout && customLength ? inMilliseconds : 20 * 60 * 1000);
    }, 500));
    _this.state = _objectSpread(_objectSpread({
      deploymentId: props.deploymentId,
      sessionId: props.sessionId,
      parentDeploymentId: undefined,
      settings: {},
      assignmentData: {},
      show404: false,
      showCompletionMsg: false,
      showLogoutMsg: false
    }, props.preloadedState), {}, {
      isLoading: !props.preloadedState
    });
    return _this;
  }
  _inherits(DeploymentPlayer, _React$Component);
  return _createClass(DeploymentPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.preloadedState) {
        this.getDeploymentData();
      }
      this.assignTimer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.assignTimer();
    }
  }, {
    key: "render",
    value:
    /* /////////////////////////////////////////////////////////////////////////
    // RENDER /////////////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////////////////// */

    function render() {
      var _this$state$pawn, _this$state$pawn2;
      var _this$state3 = this.state,
        allSurveyProgress = _this$state3.allSurveyProgress,
        assignmentData = _this$state3.assignmentData,
        completionMessage = _this$state3.completionMessage,
        deploymentId = _this$state3.deploymentId,
        sessionId = _this$state3.sessionId,
        isLoading = _this$state3.isLoading,
        parentDeploymentId = _this$state3.parentDeploymentId,
        relatedDeploymentId = _this$state3.relatedDeploymentId,
        settings = _this$state3.settings,
        show404 = _this$state3.show404,
        showCompletedMsg = _this$state3.showCompletedMsg,
        showCompletionMsg = _this$state3.showCompletionMsg,
        showLogoutMsg = _this$state3.showLogoutMsg,
        showReviewButtonOnCompletion = _this$state3.showReviewButtonOnCompletion,
        type = _this$state3.type;
      var _this$props2 = this.props,
        allowLanguageChange = _this$props2.allowLanguageChange,
        assignmentOptions = _this$props2.assignmentOptions,
        sortByAssignmentOptions = _this$props2.sortByAssignmentOptions,
        disableLayout = _this$props2.disableLayout,
        errorLayout = _this$props2.errorLayout,
        flowProps = _this$props2.flowProps,
        isFinalTestMode = _this$props2.isFinalTestMode,
        isPreviewMode = _this$props2.isPreviewMode,
        languagePicker = _this$props2.languagePicker,
        onComplete = _this$props2.onComplete,
        onModuleComplete = _this$props2.onModuleComplete,
        onFlowComplete = _this$props2.onFlowComplete,
        requiredAssignmentOptions = _this$props2.requiredAssignmentOptions,
        surveylist = _this$props2.surveylist,
        surveylistRandomizer = _this$props2.surveylistRandomizer,
        shouldSaveFlowList = _this$props2.shouldSaveFlowList,
        shouldSaveLanguage = _this$props2.shouldSaveLanguage;
      var pawnId = this.props.pawnId || ((_this$state$pawn = this.state.pawn) === null || _this$state$pawn === void 0 ? void 0 : _this$state$pawn.id);
      var pawnHash = this.props.pawnHash || ((_this$state$pawn2 = this.state.pawn) === null || _this$state$pawn2 === void 0 ? void 0 : _this$state$pawn2.random_hash);
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      if (show404) {
        if (errorLayout) {
          var ErrorLayout = errorLayout;
          return /*#__PURE__*/_react["default"].createElement(ErrorLayout, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, {
            force404: type !== 'group'
          }));
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, {
          force404: type !== 'group'
        });
      }
      if (showLogoutMsg && settings.autoLogout) {
        var anonymousLogoutMsg = /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: settings.anonAutoLogoutMessage
        });
        var knownLogoutMsg = /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: settings.knownAutoLogoutMessage
        });
        return settings.respondentConfig === 'anonymous' ? this.getPlayerLayout(anonymousLogoutMsg) : this.getPlayerLayout(knownLogoutMsg);
      }
      if (showCompletedMsg) {
        var completedMsg = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: settings.completedMessage || 'You have already completed'
        }), settings.individualPasscode && /*#__PURE__*/_react["default"].createElement(_CompletionButton["default"], {
          label: settings.passcodeCompletionButtonText
        }));
        return disableLayout ? completedMsg : this.getPlayerLayout(completedMsg);
      }
      if (showCompletionMsg) {
        var completionMsg = /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            maxWidth: '85vw'
          }
        }, /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: completionMessage || settings.completionMessage || 'You are all done'
        }), showReviewButtonOnCompletion && settings.allowRetake && !settings.isRepeated && /*#__PURE__*/_react["default"].createElement("button", {
          type: "button",
          className: "btn btn-primary float-end mt-3",
          onClick: function onClick() {
            return window.location.replace(window.location.href);
          }
        }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], null), " Review"), settings.individualPasscode && /*#__PURE__*/_react["default"].createElement(_CompletionButton["default"], {
          label: settings.passcodeCompletionButtonText
        }));
        return disableLayout ? completionMsg : this.getPlayerLayout(completionMsg);
      }
      var localOnComplete = this.setLocalOnComplete();
      var modifiedOnComplete = onComplete ? (/*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(ocLanguage, ocFlowList, ocPawnId) {
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                _context9.n = 1;
                return onComplete(ocLanguage, ocFlowList, ocPawnId);
              case 1:
                localOnComplete(ocLanguage, ocFlowList, ocPawnId);
              case 2:
                return _context9.a(2);
            }
          }, _callee9);
        }));
        return function (_x1, _x10, _x11) {
          return _ref9.apply(this, arguments);
        };
      }()) : localOnComplete;
      var updatedFlowProps = Object.assign({}, flowProps, {
        pawnHash: pawnHash,
        pawnId: pawnId,
        responseSet: deploymentId
      });
      var options = assignmentOptions.length ? assignmentOptions : settings.options;

      // Get mediator
      var mediator = this.props.mediator;
      var mediatorProps = this.props.mediatorProps;
      if (!mediator && assignmentData.navigation) {
        var currentNavigation = _navigations["default"].find(function (item) {
          return item.handle === assignmentData.navigation;
        });
        if (currentNavigation) {
          mediator = currentNavigation.mediatorComponent;
          mediatorProps = !Array.isArray(assignmentData.navigationSettings) ? Object.assign({}, assignmentData.navigationSettings, mediatorProps) : {};
        }
      }

      // For backwards compatibility
      // TODO: remove enablePrintMode from props
      if (this.props.enablePrintMode) {
        mediatorProps.enablePrintMode = this.props.enablePrintMode;
      }
      var assignment = /*#__PURE__*/_react["default"].createElement(_Assignment["default"], {
        allSurveyProgress: allSurveyProgress,
        deploymentId: deploymentId,
        sessionId: sessionId,
        deploymentSettings: settings,
        parentDeploymentId: parentDeploymentId,
        relatedDeploymentId: relatedDeploymentId,
        handle: assignmentData.handle,
        label: assignmentData.label,
        surveylists: assignmentData.surveylists,
        languages: assignmentData.languages,
        surveylistRandomizer: surveylistRandomizer,
        surveylist: surveylist,
        flowList: this.props.flowList || this.state.flowList || null,
        shouldSaveFlowList: shouldSaveFlowList,
        mediator: mediator,
        mediatorProps: mediatorProps,
        language: this.props.language || this.state.language,
        languagePicker: languagePicker,
        allowLanguageChange: allowLanguageChange,
        shouldSaveLanguage: shouldSaveLanguage,
        onComplete: modifiedOnComplete,
        onModuleComplete: onModuleComplete,
        onFlowComplete: onFlowComplete,
        onAlreadyComplete: this.onAlreadyComplete,
        flowProgress: this.props.flowProgress || this.state.flowProgress,
        flowProps: updatedFlowProps,
        options: options,
        sortByAssignmentOptions: sortByAssignmentOptions,
        requiredOptions: requiredAssignmentOptions,
        allowRetake: settings.allowRetake,
        isFinalTestMode: isFinalTestMode,
        isPreviewMode: isPreviewMode,
        showRecaptcha: settings.recaptcha,
        individualPasscode: settings.individualPasscode,
        passcodeAssistant: settings.passcodeAssistant,
        passcodeLabel: settings.individualPasscode,
        passcodeBackground: settings.passcodeBackground,
        passcodeBackgroundColor: settings.passcodeBackgroundColor,
        passcodeBackgroundUpload: settings.passcodeBackgroundUpload,
        passcodeCompletionButtonText: settings.passcodeCompletionButtonText,
        autoLogout: settings.autoLogout,
        anonAutoLogoutMessage: settings.anonAutoLogoutMessage,
        knownAutoLogoutMessage: settings.knownAutoLogoutMessage,
        autoLogoutTime: settings.autoLogoutTime,
        assignmentProgressChecked: true
      });
      if (disableLayout) {
        return assignment;
      }
      return this.getPlayerLayout(assignment);
    }
  }]);
}(_react["default"].Component);
_defineProperty(DeploymentPlayer, "propTypes", {
  /** This is one way we can look up the deployment if no deploymentId provided */
  deploymentHandle: _propTypes["default"].string,
  /** This is one way we can look it up if no */
  deploymentId: _propTypes["default"].number,
  /** The plan session id to use */
  sessionId: _propTypes["default"].number,
  /** Should we render the assignment without any wrapping? */
  disableLayout: _propTypes["default"].bool,
  /** The layout to use for the 404 page */
  errorLayout: _propTypes["default"].func,
  /** The id of the pawn against which we will record progress */
  pawnId: _propTypes["default"].number,
  /** The hash of the pawn against which we will record progress */
  pawnHash: _propTypes["default"].string,
  /** The surveylist you want to use */
  surveylist: _propTypes["default"].string,
  /** An alternate function to replace default surveylistRandomizer */
  surveylistRandomizer: _propTypes["default"].func,
  /** Should we save the selected flowList to `$pawn->data->flowList`? (default false) */
  shouldSaveFlowList: _propTypes["default"].bool,
  /** The flowList you want to use */
  flowList: _propTypes["default"].string,
  /** An alternate React Component to replace default Mediator */
  mediator: _propTypes["default"].func,
  /** Custom props for mediator */
  mediatorProps: _propTypes["default"].object,
  /** The language you want to use */
  language: _propTypes["default"].string,
  /** An alternate function to replace default LanguagePicker */
  languagePicker: _propTypes["default"].object,
  /** Should we allow changing of language? (default true) */
  allowLanguageChange: _propTypes["default"].bool,
  /** Should we save the selected language to `$pawn->data->language`? (default false) */
  shouldSaveLanguage: _propTypes["default"].bool,
  /** A function to call once assignment is complete (including non-required flows) */
  onComplete: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  /** A function to call each time a module is completed (if assignment is using withModules navigation) */
  onModuleComplete: _propTypes["default"].func,
  /** A function to call each time a flow is completed */
  onFlowComplete: _propTypes["default"].func,
  /** A function to call once the user logged out because of inactivity */
  onLogout: _propTypes["default"].func,
  /** An array of flow progress, i.e., from GraphQL. If provided, is used instead of querying for it. */
  flowProgress: _propTypes["default"].array,
  /** An array of strings for checking against `showIfOption` in flow object entries.
   * If ANY match, flow will be included. */
  assignmentOptions: _propTypes["default"].array,
  /** Respect order of survey handles passed in through assignmentOptions */
  sortByAssignmentOptions: _propTypes["default"].bool,
  /** An array of strings for checking against `showIfOption` in flow object entries.
   * If ANY match, flow `isRequired` setting will be overridden to true.
   * For flows that are not included, `isRequired` will be overridden to false. */
  requiredAssignmentOptions: _propTypes["default"].array,
  /** Override deployment setting allowRetake */
  allowRetake: _propTypes["default"].bool,
  /** Should we invoke the player in Final Test mode? */
  isFinalTestMode: _propTypes["default"].bool,
  /** Should we skip saving everything and not run any pre/postFlowRoutes? */
  isPreviewMode: _propTypes["default"].bool,
  /** An object containing props that each flow should have */
  flowProps: _propTypes["default"].object,
  /** An object with preloaded state values. Used to reduce the query numbers. */
  preloadedState: _propTypes["default"].object,
  /**
   * !DEPRECATED
   * Flag to set enablePrintMode in mediatorProps
   * TODO: Remove enablePrintMode from props
   */
  enablePrintMode: _propTypes["default"].bool
});
_defineProperty(DeploymentPlayer, "defaultProps", {
  disableLayout: false,
  errorLayout: null,
  surveylist: null,
  surveylistRandomizer: null,
  shouldSaveFlowList: false,
  mediator: null,
  mediatorProps: {},
  languagePicker: null,
  allowLanguageChange: true,
  shouldSaveLanguage: false,
  onComplete: null,
  onModuleComplete: null,
  onFlowComplete: null,
  flowProgress: null,
  assignmentOptions: [],
  sortByAssignmentOptions: false,
  requiredAssignmentOptions: null,
  allowRetake: null,
  isFinalTestMode: false,
  isPreviewMode: false,
  flowProps: {}
});